import { ComponentPropsWithoutRef } from 'react';
import { Button } from '@givebutter/primitives/button';

const TabButton = ({
    active,
    className,
    ...props
}: { active?: boolean } & Omit<ComponentPropsWithoutRef<'button'>, 'color'>) => (
    <Button
        variant="none"
        color={active ? 'primary' : 'neutral'}
        className={`${className} border-b-2 px-1 py-2 font-medium ${
            active ? 'border-blue-700' : 'border-transparent text-gray-500'
        }`}
        {...props}
    />
);

export { TabButton };
